import { StreamLanguage } from "@codemirror/language";
import { Extension } from "@codemirror/state";

const dollarLanguage = StreamLanguage.define({
  startState() {
    return { inDollarString: false };
  },
  token(stream, state) {
    if (!state.inDollarString && stream.match("$$")) {
      // eslint-disable-next-line no-param-reassign
      state.inDollarString = true;
      return "string";
    }
    if (state.inDollarString) {
      if (stream.skipTo("$$")) {
        stream.match("$$");
        // eslint-disable-next-line no-param-reassign
        state.inDollarString = false;
      } else {
        stream.skipToEnd();
      }
      return "string";
    }
    if (stream.match(/["'`]/)) {
      stream.skipToEnd();
      return "string";
    }
    stream.next();
    return null;
  },
});

export const doubleDollarAsString: Extension = [
  dollarLanguage,
  dollarLanguage.data.of({ commentTokens: { line: "--" } }),
];
